import React from "react";
import { Nav, Dropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const GenerateMenuItems = ({ options }) => (
    options.map((item, index) => (
        <Dropdown.Item
            key={`menu-item-${item.id}-${item.name || index}`}
            as={NavLink}
            to={{
                pathname: item.href,
                state: {
                    id: item.id || "",
                    newProject: item.newProject || null,
                    preSelectReportID: item.preSelectReportID || null,
                },
            }}
            onClick={item.onClick || null}
            onKeyDown={(e) => {
                if (e.key === " " || e.key === "Spacebar") {
                    e.preventDefault(); // Prevent scroll
                    e.target.click();   // Trigger click manually
                }
            }}
            role="menuitem"
            className="dropdown-with-icons dropdown-link"
        >
            <i className={item.icon || ""} /> {item.name}
        </Dropdown.Item>
    ))
);

const KnoaDropdownNavMain = ({ options, menuIcon = undefined }) => {
    const { t } = useTranslation();
    const dropdownId = menuIcon ? "basic-nav-dropdown-4" : "basic-nav-dropdown-3";
    const iconClass = menuIcon
        ? `${menuIcon} filter-moreoption-menu navbar-icon`
        : "pe-7s-menu navbar-icon";

    return (
        <Nav className="ms-auto align-items-center">
            <div className="NavBar-btn-container knoa-region d-flex align-items-center">
                <Dropdown as={Nav.Item} className="navbar-dropdown-toggle dropdown-with-icons">
                    <Dropdown.Toggle
                        as={Nav.Link}
                        id={dropdownId}
                        variant="default"
                        aria-label={t("common:options")}
                        className="navbar-dropdown-toggle"
                    >
                        <i className={iconClass} title={t("common:options")} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end" className="dropdown-with-icons">
                        <GenerateMenuItems options={options} />
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </Nav>
    );
};

KnoaDropdownNavMain.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        icon: PropTypes.string,
        id: PropTypes.number,
        newProject: PropTypes.bool,
        preSelectReportID: PropTypes.string,
        onClick: PropTypes.func,
    })).isRequired,
    menuIcon: PropTypes.string,
};

export default KnoaDropdownNavMain;